
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { inject } from '@angular/core';
import { map } from 'rxjs';
import { WatcherService } from '../services/watcher.service';

export const FunnelGuard: CanActivateFn = (route, state) => {
  const store = inject(Store)
  const router = inject(Router)
  const _watcherService = inject(WatcherService);
  let _lang = 'en';
  _watcherService.getLang().subscribe(lang => {
    _lang = lang;
  });
  return store.select('auth').pipe(
    map(authRes => {
      const user = authRes.user;
      const unix_timestamp = user['date'];
      const newHostDate = 1651093200;
      const oldHostDate = new Date(unix_timestamp * 1000);
      const newHostDateTimestamp = new Date(newHostDate * 1000);
      switch (user?.type) {
        case 2:
          if (
            user['profile_image_url'] == "/assets/img/nobody-256.jpg" ||
            user['name'] == "" || user['surname'] == "" ||(
            user['user_profile']['social_media']['facebook_url'] == "" &&
            user['user_profile']['social_media']['instagram_url'] == "" &&
            user['user_profile']['social_media']['twitter_url'] == "" &&
            user['user_profile']['social_media']['linkedin_url'] == "")
          ) {
            router.navigate(['/', 'host-funnel', 'profile'])
            return false;
          } else {
            if (user['addresses'].length == 0) {
              router.navigate(['/', 'host-funnel', 'address'])
              return false;
            } else {
              if (user['addresses'].length > 0 && user['passport_id_url'].length == 0 && user['national_id_url'].length == 0) {
                router.navigate(['/', 'host-funnel', 'documents'])
                return false;
              } else {

                if (user['host_agreement_signed'] == 0 && oldHostDate > newHostDateTimestamp) {
                  router.navigate(['/', 'host-funnel', 'documents'])
                  return false;
                } else {
                  return true;
                }
              }
            }
          }
        default:
          return true;
      }
    })
  )
}
